import { useState } from "react";
import { Gift, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { RewardPicker } from "@/components/loyalty/RewardPicker";
import { brl } from "@/lib/api";
import { fmtPts } from "@/lib/loyalty";

function Applied({ calc, sel, freeDel, onRemove }) {
  const { rs, loyOff } = calc(sel, freeDel);
  const what = [loyOff > 0 && `desconto de ${brl(loyOff)}`, ...rs.products.map((r) => `${r.name} grátis`), rs.deliveryOff > 0 && "entrega grátis"].filter(Boolean).join(" · ");
  return (
    <div className="flex items-center gap-3 rounded-xl border border-emerald-300 bg-emerald-50 p-3 text-sm text-emerald-800" data-testid="shop-points-applied">
      <Gift className="h-5 w-5 shrink-0" />
      <span className="flex-1">Pontos aplicados: usando <b>{fmtPts(rs.points)}</b>{what ? ` · ${what}` : ""}</span>
      <button type="button" onClick={onRemove} className="flex items-center gap-1 text-xs font-semibold hover:underline" data-testid="shop-points-remove"><X className="h-3.5 w-3.5" />Remover</button>
    </div>
  );
}

function Picker({ wallet, calc, allowFree, color, onCancel, onConfirm }) {
  const [sel, setSel] = useState([]);
  const [freeDel, setFreeDel] = useState(false);
  const { rs, loyOff, total } = calc(sel, freeDel);
  const chosen = sel.length > 0 || freeDel;
  return (
    <div className="space-y-3 rounded-xl border p-3" style={{ borderColor: color }} data-testid="shop-points-panel">
      <p className="text-sm">Você tem <b data-testid="shop-points-balance">{fmtPts(wallet.balance)}</b>. Escolha a recompensa:</p>
      <RewardPicker wallet={wallet} sel={sel} setSel={setSel} freeDel={freeDel} setFreeDel={setFreeDel} allowFreeDelivery={allowFree} color={color} />
      {chosen && (
        <div className="space-y-0.5 rounded-lg bg-slate-100 p-3 text-sm" data-testid="shop-points-preview">
          {loyOff > 0 && <p className="flex justify-between text-emerald-700"><span>Desconto no total</span><b data-testid="shop-points-discount">- {brl(loyOff)}</b></p>}
          {rs.products.map((r) => <p key={r.id} className="flex justify-between text-emerald-700"><span>Brinde</span><b>{r.name} grátis</b></p>)}
          {rs.deliveryOff > 0 && <p className="flex justify-between text-emerald-700"><span>Entrega grátis</span><b>- {brl(rs.deliveryOff)}</b></p>}
          <p className="flex justify-between font-semibold"><span>Total com os pontos</span><span data-testid="shop-points-new-total">{brl(total)}</span></p>
        </div>
      )}
      <div className="grid grid-cols-2 gap-2">
        <Button type="button" variant="outline" className="bg-white" onClick={onCancel} data-testid="shop-points-cancel">Cancelar</Button>
        <Button type="button" className="text-white" style={{ background: color }} disabled={!chosen} onClick={() => onConfirm(sel, freeDel)} data-testid="shop-points-confirm">Confirmar</Button>
      </div>
    </div>
  );
}

export function UseButton({ label, onClick, color }) {
  return (
    <button type="button" onClick={onClick} className="flex w-full items-center gap-3 rounded-xl border-2 p-3 text-left transition-colors hover:bg-slate-50" style={{ borderColor: color }} data-testid="shop-use-points-btn">
      <Gift className="h-6 w-6 shrink-0" style={{ color }} />
      <span className="flex-1"><span className="block font-semibold" data-testid="shop-use-points-label">{label}</span><span className="text-xs text-slate-500">Troque por desconto ou brinde neste pedido</span></span>
    </button>
  );
}

export function PointsBox({ wallet, label, startOpen = false, sel, freeDel, apply, calc, allowFree, color }) {
  const [open, setOpen] = useState(startOpen);
  if (!(wallet.balance > 0)) return null;
  if (sel.length || freeDel) return <Applied calc={calc} sel={sel} freeDel={freeDel} onRemove={() => apply([], false)} />;
  if (open) return <Picker wallet={wallet} calc={calc} allowFree={allowFree} color={color} onCancel={() => setOpen(false)} onConfirm={(s, f) => { apply(s, f); setOpen(false); }} />;
  return <UseButton label={label} onClick={() => setOpen(true)} color={color} />;
}
